// 生产环境
let config = {
  baseUrl: "http://localhost:9900", // 生产网关地址
  tokenName: "EDU_WEB_TOKEN",
  tokenExpires: 60 * 60 * 1000, // token 过期时间为1个小时
}
// 生产环境
// let config = {
//   tokenName: 'EDU_WEB_TOKEN',
//   isIp: false,  // 是否ip部署 如果上生产 设置为false
//   tokenExpires: 60 * 60 * 1000, // token 过期时间为1个小时
//   baseUrl: 'http://127.0.0.1:9701/gateway', // 生产网关地址
//   url: 'jcwlen4dpvkvf6lk.jc-ft.com', // 店铺域名，本地开发使用，生产不用配置该属性
// }

if (process.env.NODE_ENV === "development") {
  // 开发环境
  config = {
    ...config,
    baseUrl: 'http://120.46.170.9:9900', // 开发网关地址 线上
    // baseUrl: "http://192.168.0.116:9900", // 开发网关地址
    // url: 'eduesr3w39n6rxx.roncoo.com' // 店铺域名，本地开发使用，生产不用配置该属性
    url: "jcwlen4dpvkvf6lk.jc-ft.com", // 店铺域名，本地开发使用，生产不用配置该属性
  };
}
export default config;
